<script>
import ReportMixin from '@/mixins/report'

export default {
  name: 'Report',
  mixins: [ReportMixin],
  data() {
    return {
      reportDescription: '',
      reportDetails: {},
      formKey: 0,
      allReportData: [],
      reportRan: false,
      reportParameters: {}
    }
  },
  watch: {
    name: function() {
      this.loadThisReportDetails()
    }
  },
  computed: {
    reportQuery() {
      return this.buildReportQuery(this.reportDetails)
    },
    allFormData() {
      return {
        ...(this.reportParameters ||
          this.$refs['graphql-form'].$refs.form.formData),
        ...(this.allReportData && this.allReportData.length
          ? this.allReportData[0]
          : {})
      }
    },
    reportFields() {
      return this.getReportFields(this.reportDetails)
    },
    reportRecords() {
      return this.getReportRecords(this.allReportData, this.reportFields)
    }
  },
  methods: {
    loadThisReportDetails(fromLoad) {
      this.reportRan = false
      this.loadReportDetails(this.name).then(data => {
        this.reportDetails = null
        if (data.allMetricsDashReports.nodes.length) {
          this.reportDescription =
            data.allMetricsDashReports.nodes[0].reportDescription
          this.reportDetails = data.allMetricsDashReports.nodes[0].reportDetails
          this.formTypes.CURRENT_REPORT.form.schema =
            this.reportDetails.formSchema || []
          this.formKey++
          this.allReportData = []
          if (fromLoad) {
            if (this.$route.query.filters) {
              let setFormData = () => {
                if (
                  this.$refs['graphql-form'].$refs.form.optionsLoaded == false
                ) {
                  setTimeout(setFormData, 250)
                  return
                }
                this.$set(
                  this.$refs['graphql-form'],
                  'formData',
                  JSON.parse(this.$route.query.filters)
                )
              }
              setTimeout(setFormData, 250)
              this.formSubmit(JSON.parse(this.$route.query.filters))
            } else if (this.$route.query.run == 'true') {
              setTimeout(() => {
                this.$refs['graphql-form'].$refs.form.submitForm()
              }, 100)
            }
          }
        }
      })
    },
    formSubmit(submitData) {
      this.reportParameters = submitData
      this.reportRan = false
      this.allReportData = []
      this.resultsCurrentPage = 1
      window.reportDone = false
      this.graphql(this.reportQuery, submitData).then(data => {
        if (Object.keys(data).length == 1) {
          if (Object.keys(data[Object.keys(data)[0]]).length == 1) {
            this.allReportData =
              data[Object.keys(data)[0]][
                Object.keys(data[Object.keys(data)[0]])[0]
              ]
            // This is to clear the loading screen if running with parameters (scheduled or favorite) and not all the select options have come back
            if (window.formActionPopups.showLoading) {
              window.formActionPopups.showLoading = 0
            }
          }
        }
        this.reportRan = true
      })
    }
  },
  mounted() {
    window.reportDone = false
    this.loadThisReportDetails(true)
  }
}
</script>

<template>
  <div>
    <h1 v-if="reportDetails == null">Report Not Found: {{ name }}</h1>
    <Container v-else :expanded="!reportRan">
      <template v-slot:header>Report Details: {{ name }}</template>
      <template v-slot:content>
        <p
          class="m-2 text-center report-details-description"
          v-html="reportDescription"
        ></p>
        <hr />
        <GraphQLFormEdit
          formType="CURRENT_REPORT"
          :submitTriggerInsteadOfSave="true"
          @submitForm="formSubmit"
          :key="formKey"
          v-if="formKey"
          ref="graphql-form"
          :showResetButton="formTypes.CURRENT_REPORT.form.schema.length > 0"
        />
      </template>
    </Container>
    <h1 v-if="reportRan && !reportRecords.length" class="text-center">
      No Results Found
    </h1>
    <ReportResults
      :reportName="name"
      :reportRecords="reportRecords"
      :reportParameters="reportParameters"
      :reportFields="reportFields"
      :chartTypes="reportDetails.chartTypes"
      :chartType="this.$route.query.chartType || reportDetails.defaultChartType"
      :reportDetails="reportDetails"
      :allowActions="true"
      v-else-if="reportRan"
    />
  </div>
</template>

<style>
.report-details-description .report-details-only {
  display: inline-block;
}
</style>
